export default __webpack_public_path__ + "64bb1232a5b45d789f9b91ee03159ef0.jpg";